module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M27.991 20.629a2.353 2.353 0 0 0-3.326 0l-1.662 1.662a2.35 2.35 0 0 1-3.324 0l-9.967-9.969a2.35 2.35 0 0 1 0-3.324l1.662-1.66a2.35 2.35 0 0 0 0-3.324L8.05.69a2.352 2.352 0 0 0-3.324 0L.571 4.847c-.458.458-.696 1.34-.5 1.958C1.795 12.254 5.47 18.05 9.712 22.293c4.241 4.241 10.039 7.917 15.488 9.637.62.198 1.502-.042 1.96-.5l4.155-4.153a2.35 2.35 0 0 0 0-3.324l-3.322-3.322z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/call-1.js
// module id = 1039
// module chunks = 14